import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/documento-honorario-asimilado';
const headers = { 'Content-Type': 'multipart/form-data' };
const files = ['archivo'];
/**
 * GET Documentos Honorarios Asimilados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosHonorariosAsimilados = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Documento Honorario Asimilado
 * @param {object} params
 * @returns {Promise<object|null>}
 */
export const getDocumentoHonorarioAsimilado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Documentos Honorarios Asimilados params
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosHonorariosAsimiladosParams = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Documento Honorario Asimilado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDocumentoHonorarioAsimilado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Documento Honorario Asimilado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentoHonorarioAsimilado = async (id, values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(`${baseURI}/${id}`, formattedValues);
    // const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Documento Honorario Asimilado
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteDocumentoHonorarioAsimilado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Documentos Honorario Asimilado Status
 * @param {object} values
 * @returns {Promise<{}>}
 */
export const putDocumentosHonorarioAsimiladoStatus = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-documentos-honorario-asimilado-status', values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
